import { createFileRoute } from "@tanstack/react-router";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useFetch } from "../../../../../hooks/api";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../redux/hooks";
import { keepPreviousData } from "@tanstack/react-query";

interface ReportCardOverviewResponse {
  active_anomalies: { name: string; anomalies: { org_id: number; org_name: string; value: number }[] }[];
}

const ReportCardOverview = () => {
  const { t } = useTranslation(["admin"]);
  const { data, isFetching } = useFetch<ReportCardOverviewResponse>(
    ["reportcard"],
    "/api/reportcard/",
    {},
    {
      select: (response) => response.data,
      retry: 3,
      placeholderData: keepPreviousData,
    },
  );

  const user = useAppSelector((state) => state.user);

  return (
    <Container
      style={{
        minHeight: "100%",
      }}
    >
      <Row>
        <Col>
          <h1 className={"fs-1"}>{t(($) => $.admin.reportCard["System Report Card"])}</h1>
          <ul className={"list-group list-group-horizontal-sm"}>
            <a href={`/user/staff/reportcard/${user.organization_id}`} className={"list-group-item"}>
              {t(($) => $.admin.reportCard["View Current Organization"])}
            </a>
            {isFetching && (
              <li className={"list-group-item"}>
                <i className="fa fa-spinner fa-spin"></i> {t(($) => $.admin.reportCard["Updating..."])}
              </li>
            )}
          </ul>
          <hr />
        </Col>
      </Row>
      {data && (
        <Row>
          <Col>
            <h2 className={"fs-2"}>{t(($) => $.admin.reportCard["Organizations With Active Anomalies"])}</h2>
            {data.active_anomalies.map((group, index) => {
              return (
                <Fragment key={index}>
                  <h3 className={"fs-3"}>
                    <strong>{group.name}</strong> - {t(($) => $.admin.reportCard["anomaly"])}
                  </h3>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>{t(($) => $.admin.reportCard["Anomalies"])}</th>
                        <th>{t(($) => $.admin.reportCard["Organization Name"])}</th>
                        <th>{t(($) => $.admin.reportCard["Organization ID"])}</th>
                        <th>{t(($) => $.admin.reportCard["Links"])}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {group.anomalies
                        .sort((a, b) => b.value - a.value)
                        .map((item, index) => {
                          return (
                            <tr key={index}>
                              <td className={"text-center"}>{item.value}</td>
                              <td className={"text-center"}>{item.org_name}</td>
                              <td className={"text-center"}>{item.org_id}</td>
                              <td className={"text-end"}>
                                <ul className={"list-group list-group-horizontal-sm d-flex justify-content-end"}>
                                  <a href={`/user/staff/reportcard/${item.org_id}/`} className={"list-group-item"}>
                                    {t(($) => $.admin.reportCard["Report Card"])}
                                  </a>
                                </ul>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </Fragment>
              );
            })}
          </Col>
        </Row>
      )}
    </Container>
  );
};

export const Route = createFileRoute("/_authenticated/user/staff/reportcard/")({
  component: ReportCardOverview,
});
